export default {
    videoName: "The Holy Road",
    videos: {
        id: "VideoEN",
        mobile: {
            src: "https://output.scrollytelling.io/theholyroad/videos/De_Weg_Eng28dec_(RES_12802).mp4",
            type: "video/mp4"
        },
        desktop: {
            src: "https://output.scrollytelling.io/theholyroad/videos/De_Weg_Eng28dec_(MP4_2).mp4",
            type: "video/mp4"
        },
        dash: {
          src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/319/dash/manifest.mpd",
          type: "application/dash+xml"
        },
        hls: {
          src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/319/hls-fullhd.m3u8",
          type: "application/x-mpegURL"
        }
    },
    introText: "The Holy Road is an interactive web documentary about people living along side the holiest but also most controversial road through Israel and Palestine: Route 60.",
    startRoute: "Start your journey",
    rijVerder: "continue driving",
    terugNaarRoadMovie: "BACK TO ROADMOVIE"
}



// WEBPACK FOOTER //
// ./src/data/video.js